import {User} from "../entities/User";
import {BaseService} from "./BaseService";
import { StateService } from "@uirouter/angularjs";

export class UserService extends BaseService<User>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, User);
    }
    protected getBaseUrl():string{
        return "user";
    }
}
